<ion-header>
  <ion-toolbar>
    <ion-title>{{ currentIndex + 1 }} / {{ images.length }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="_modalCtrl.dismiss()">
        <span color="primary"> {{ 'CANCEL_BUTTON' | translate }} </span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content scroll="false">
  <swiper-container
    #swiperRef
    [pagination]="true"
    [initialSlide]="currentIndex"
    (slidechange)="slideChanged()"
    class="swiper-container"
  >
    <swiper-slide *ngFor="let image of images">
      <img [src]="image" class="lightbox-image" />
    </swiper-slide>
  </swiper-container>
</ion-content>
